import { UserEntity } from './user-entity';


export abstract class UserRepository
{

 

}
